import React from 'react'
import {connect} from 'react-redux'
import {Button, Col, Divider, Form, Input, message, Radio, Row, Spin, Typography} from 'antd'
import {getArtist, getArtistProfile, patchArtist} from '../../api/artists'
import {getArtistNames, putArtistNames} from '../../api/artistNames'
import {userDeactivate} from '../../api/user'
import {IN_PRODUCT} from '../../config/product'

import FormChangePwd from '../../component/account/FormChangePwd'

import {URL_CANCEL_ACCOUNT} from '../../const'
import AddorUpdateButton from "../../component/base/AddorUpdateButton";
import HttpError from "../../component/base/HttpError";
import Taxes from "../../component/account/Taxes";
import Billing from "../Billing";

const {Title} = Typography

@connect((state) => ({
    userId: state.user.info.userId,
    artistId: state.user.info.artistId,
    email: state.user.info.email
}))
class Info extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            imageLoading: false,
            loading: false,
            pseudonymInputVisible: true,
            email: props.email,
            base_url: IN_PRODUCT ? 'https://revart.co' : 'http://localhost:8000',
            artist_name: '',
            isP1ModalVisible: false,
            isP2ModalVisible: false,
            isP3ModalVisible: false
        }
        this.formRef = React.createRef()

        this.showDeactivateModalP1 = () => {
            this.setState({
                isP1ModalVisible: true,
                isP2ModalVisible: false,
                isP3ModalVisible: false
            })
        }

        this.deactivateModalP1OK = () => {
            this.setState({
                isP1ModalVisible: false,
                isP2ModalVisible: true,
                isP3ModalVisible: false
            })
        }

        this.deactivateModalP1Cancel = () => {
            this.setState({
                isP1ModalVisible: false,
                isP2ModalVisible: false,
                isP3ModalVisible: false
            })
        }

        this.deactivateModalP2OK = () => {
            this.setState({
                isP1ModalVisible: false,
                isP2ModalVisible: false,
                isP3ModalVisible: true
            })
        }

        this.deactivateModalP2Cancel = () => {
            this.setState({
                isP1ModalVisible: false,
                isP2ModalVisible: false,
                isP3ModalVisible: false
            })
        }

        this.deactivateModalP3OK = () => {
            userDeactivate(this.props.userId)
                .then((response) => {
                    window.location.reload()
                })
                .catch((error) => {
                    message.error(error.message).then((r) => {
                    })
                })
                .finally(() => {
                    this.setState({
                        isP1ModalVisible: false,
                        isP2ModalVisible: false,
                        isP3ModalVisible: false
                    })
                })
        }

        this.deactivateModalP3Cancel = () => {
            this.setState({
                isP1ModalVisible: false,
                isP2ModalVisible: false,
                isP3ModalVisible: false
            })
        }
    }

    componentDidMount() {
        if (!this.props.userId || !this.props.artistId) return
        this.setState({loading: true})
        Promise.all([getArtistNames(this.props.artistId), getArtist(this.props.userId)]).then((results)=>{
            const artistNames = results[0].data
            const artist = results[1].data
            this.initializeFieldsValue(artist, artistNames)
            this.setState({
                artist_id: artist.id,
                artist_name: this.getArtistName(artistNames.first_name, artistNames.middle_name, artistNames.last_name, artistNames.nick_name)
            })
        }).catch((error)=>{
            HttpError(error)
        }).finally(()=>{
            this.setState({loading: false})
        })
    }

    initializeFieldsValue = (artist, artistNames) => {
        if (this.formRef.current == null) return
        this.formRef.current.setFieldsValue({
            email: this.props.email,
            firstName: artistNames.first_name,
            middleName: artistNames.middle_name,
            lastName: artistNames.last_name,
            nickName: artistNames.nick_name,
            nameSelect: artist.name_select,
            pseudonym: artist.pseudonym,
        })
        this.setState({
            pseudonymInputVisible: artist.name_select === 'pseudonym'
        })
    }

    handleFormValuesChange = (changedValues, allValues) => {
        this.setState({
            pseudonymInputVisible: allValues.nameSelect === 'pseudonym'
        })
    }

    onFinish = (values) => {
        if (!this.props.artistId || !this.props.userId) return
        const {firstName, middleName, lastName, nickName} = values
        const artistNamesParam = {
            first_name: firstName,
            middle_name: middleName === '' ? null : middleName,
            last_name: lastName,
            nick_name: nickName,
            artist: this.props.artistId
        }
        const {
            nameSelect,
            pseudonym,
        } = values
        const artistParam = {
            name_select: nameSelect,
            pseudonym: pseudonym,
        }
        this.setState({loading: true})
        Promise.all([
            putArtistNames(this.props.artistId, artistNamesParam),
            patchArtist(this.props.userId, artistParam),
        ]).then((response) => {
            message.success('Update successfully').then(() => {})
        })
        .catch((error) => {
            HttpError(error)
        }).finally(()=>{
            this.setState({loading: false})
        })
    }

    getArtistName = (first, middle, last, pseudonym) => {
        if (pseudonym && pseudonym?.toString() !== '') {
            return pseudonym
        }
        if (middle && middle?.toString() !== '') {
            return first + ' ' + middle + ' ' + last
        }
        return first + ' ' + last
    }

    render() {
        return (
            <Spin size='small' spinning={this.state.loading}>
                <Form
                    style={{paddingLeft: '4%', paddingRight: '4%'}}
                    labelCol={{span: 4}}
                    wrapperCol={{span: 16}}
                    colon={false}
                    ref={this.formRef}
                    onValuesChange={this.handleFormValuesChange}
                    onFinish={this.onFinish}
                >
                    <Row justify='space-around' gutter={{xs: 8, sm: 16, md: 24}} wrap={true}>
                        <Col span={24}>
                            <Title>My Account</Title>
                            <Form.Item name='email' label='Email address' style={{marginTop: 24}}>
                                <Input disabled/>
                            </Form.Item>
                            <Form.Item
                                name='firstName'
                                label='First name'
                                rules={[
                                    {
                                        required: true,
                                        type: 'string',
                                        max: 100,
                                        min: 1
                                    }
                                ]}
                            >
                                <Input/>
                            </Form.Item>
                            <Form.Item
                                name='middleName'
                                label='Middle Name'
                                rules={[
                                    {
                                        type: 'string',
                                        max: 100,
                                        min: 1
                                    }
                                ]}
                            >
                                <Input/>
                            </Form.Item>
                            <Form.Item
                                name='lastName'
                                label='Last Name'
                                rules={[
                                    {
                                        required: true,
                                        type: 'string',
                                        max: 100,
                                        min: 1
                                    }
                                ]}
                            >
                                <Input/>
                            </Form.Item>
                            <Form.Item name='nameSelect' label=' '>
                                <Radio.Group buttonStyle='solid'>
                                    <Radio.Button value='realname'>Use Real Name (Recommended)</Radio.Button>
                                    <Radio.Button value='pseudonym'>Use a Pseudonym</Radio.Button>
                                </Radio.Group>
                            </Form.Item>
                            {this.state.pseudonymInputVisible === false ? null : (
                                <Form.Item
                                    name='pseudonym'
                                    label='Pseudonym'
                                    rules={[
                                        {
                                            required: true,
                                            type: 'string',
                                            max: 100,
                                            min: 1
                                        }
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                            )}
                            <div
                                style={{
                                    width: '100%',
                                }}
                            >
                                <div style={{float: 'right', marginRight: '11%'}}>
                                    <AddorUpdateButton text={this.props.saveBtnTitle ?? 'Save'} {...this.props} />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Form>
                <Divider/>
                <FormChangePwd/>
                <Divider/>
                <Taxes/>
                <Divider/>
                <Row justify='space-around' gutter={{xs: 8, sm: 16, md: 24}} wrap={true} style={{marginTop: 12}}>
                    <Col span={24}>
                        <Title>Cancel/Deactivate Account</Title>
                        <b>If you wish to cancel or deactivate your account, please click the button below.</b>
                        <br/>
                        <br/>
                        <Button danger href={URL_CANCEL_ACCOUNT} style={{float: 'right', marginRight: '11%'}}>
                            Cancel/Deactivate
                        </Button>
                    </Col>
                </Row>
            </Spin>
        )
    }
}

export default Info
